import { https } from 'mk-biz-pc'
import { Config } from './config'

const coreApi = https.coreApi

/**
 * 获取公共key
 */
export const getKey = () => coreApi(Config.getPublicKey)

/**
 * 用户登录
 * @param account
 * @param password
 * @param key
 * @param code
 * @returns
 */
export const login = (account: string, password: string) => {
  return coreApi(Config.userLogin, {
    data: {
      account,
      password
    },
    cancelGlobalMsg: true
  })
}

/**
 * 用户修改密码
 * @param oldPassword
 * @param newPassword
 * @returns
 */
export const updatePassword = (oldPassword: string, newPassword: string) => {
  return coreApi(Config.updatePassword, {
    data: {
      oldPassword,
      newPassword
    },
    cancelGlobalMsg: true
  })
}

/**
 * 获取图形验证码
 * @returns
 */
export const getVerifyCode = () => coreApi(Config.getVerifyCode)

/**
 * 退出
 * @returns
 */
export const logout = () => coreApi(Config.userLogout)

/**
 * 获取用户应用
 */
export const getApps = () => coreApi(Config.getApps)

/**
 * 获取用户导航
 */
export const getNavs = () => coreApi(Config.getNavs)

/**
 * 获取功能点
 * @returns
 */
export const getFunctions = () => coreApi(Config.getFunctions)

/**
 * 获取用户信息
 * @returns
 */
export const getUser = () => coreApi(Config.getUser)
